module.exports = __webpack_public_path__ + "img/p5.9bdec26.jpg";